export default __webpack_public_path__ + "static/media/Group 109.80189e7b.svg";